import { useAccountBadgeBulkActions } from '../../../../../ui/features/badge-management/hooks/useAccountBadgeBulkActions';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import AddIcon from '@mui/icons-material/Add';
import BlockIcon from '@mui/icons-material/Block';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SendIcon from '@mui/icons-material/Send';
import React from 'react';
import { useAccountBadgeTable } from '../../hooks/useAccountBadgeTable';
export const AccountBadgeTable = ({ badgeId, accountBadges, fetchBadgeDetails }) => {
    var _a;
    const { t } = useBadgingTranslation();
    const { dataTableProps, reload } = useAccountBadgeTable({ badgeId });
    const reloadAccountBadgeData = React.useCallback(() => {
        void fetchBadgeDetails();
        reload();
    }, [fetchBadgeDetails, reload]);
    const bulkActions = useAccountBadgeBulkActions({
        badgeId,
        accountBadgesAll: accountBadges,
        accountBadgeRows: dataTableProps.rows,
        accountBadgeSelectedIds: (_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [],
        onActionCompleted: reloadAccountBadgeData,
    });
    return (React.createElement(DataTable, Object.assign({}, dataTableProps, { globalActions: [
            {
                icon: React.createElement(AddIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.addAccount'),
                disabled: !bulkActions.canAddAccount,
                onClick: bulkActions.handleAddAccount,
            },
        ], localActions: [
            {
                icon: React.createElement(SendIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.notify'),
                disabled: !bulkActions.canNotify,
                onClick: () => { },
            },
            {
                icon: React.createElement(PrintOutlinedIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.print'),
                disabled: !bulkActions.canPrint,
                onClick: () => { },
            },
            {
                icon: React.createElement(BlockIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.revoke'),
                disabled: !bulkActions.canRevoke,
                onClick: () => { },
            },
            {
                icon: React.createElement(PublishedWithChangesIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.changeDistribution'),
                disabled: !bulkActions.canEditDistributionStatus,
                onClick: () => { },
            },
            {
                icon: React.createElement(HowToRegIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.markAsDistributed'),
                disabled: !bulkActions.canEditDistributionStatus,
                onClick: () => { },
            },
            {
                icon: React.createElement(FactCheckOutlinedIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.markAsPrinted'),
                disabled: !bulkActions.canEditDistributionStatus,
                onClick: () => { },
            },
            {
                icon: React.createElement(PrintOutlinedIcon, null),
                label: t('badges.badgeDetails.accountBadgeTable.actions.reissue'),
                disabled: !bulkActions.canReissue,
                onClick: bulkActions.handleReissueAccountBadges,
            },
        ] })));
};
